
//virtualSimulation
<template>
  <div>
    <!-- <div @click="changeLoad"> -->
      <Upload
        class="mycamera"
        ref="upload"
        :name="isImg=='img'?nameImg:nameVideo"
        :show-upload-list="false"
        :default-file-list="defaultList"
        :on-success="handleSuccess"
        :format="isImg=='img'?formatImg:formatVideo"
        :on-format-error="handleFormatError"
        :on-exceeded-size="handleMaxSize"
        type="drag"
        :action="isImg=='img'?port+actionImg:port+actionVideo"
      >
        <div class="icon-box">
          <div v-if="uploadList.length>0">
            <div v-for="(item,index) in uploadList" :key="index">
              <div v-if="index==uploadList.length-1">
                <template v-if="item.status === 'finished'">
                  <img v-if="isImg=='img'" :src="port+item.url">
                  <video v-else :src="port+item.url"></video>
                </template>
                <template v-else>
                  <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
                </template>
              </div>
            </div>
          </div>
          <div v-else>
            <Icon type="ios-camera" size="50"></Icon>
          </div>
        </div>
      </Upload>
    <!-- </div> -->
    <!-- <div class="load" v-if="isLoad">
      正在扫描文件
      <img src="../assets/imgs/load.gif" alt>
    </div> -->
  </div>
</template>

<script>
import * as homeConst from "../apiconfig/index.js";
import * as homeApi from "../api/teacher-api.js";
import * as allFn from "../utils/index.js";
import { setTimeout } from "timers";
export default {
  name: "myUpload",
  props: ["defaultList", "isImg"],
  data() {
    return {
      port: homeConst.baseUrl + "/",
      uploadList: [],
      nameImg: "Image",
      nameVideo: "Video",
      formatImg: ["jpg", "jpeg", "png"],
      formatVideo: ["mp4"],
      actionImg: "api/public/Upload/UploadImage/",
      actionVideo: "api/public/Upload/UploadVideo/",
      isLoad: false
    };
  },
  created() {},
  mounted() {
     this.uploadList = this.$refs.upload.fileList;
  },
  watch: {},
  methods: {
    // 判断文件格式是否正确
    handleFormatError(file) {
      this.isLoad=false;
      this.$Message.error({
        content: file.name + "文件格式不正确",
        duration: 3
      });
    },
    // 判断文件大小是否符合要求
    handleMaxSize(file) {
      this.isLoad=false;
      this.$Message.error({
        content: file.name + "文件大小超出范围",
        duration: 3
      });
    },
    // 上传成功
    handleSuccess(res, file) {
      this.isLoad = false;
      file.url = res.msg;
      if (this.uploadList.length > 0) {
        this.$emit("getUrlList", this.uploadList);
      } else {
        this.$emit("getUrlList", this.$refs.upload.fileList);
      }
    },
    // changeLoad() {
    //   var _that = this;

    //   setTimeout(function() {
    //     _that.isLoad = true;
    //   }, 1000);
    // }
  }
};
</script>

<style>
</style>